/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { CashBoxReplacementHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';

export enum CashBoxReplacementTabActionType {
    EXIT_CASHBOX_REPLACEMENT_TAB = 'CashBoxReplacementTab/ exit tab',
    FETCH_CASHBOX_REPLACEMENT_HISTORY = 'CashBoxReplacementTab/ fetch replacement history start',
    FETCH_CASHBOX_REPLACEMENT_HISTORY_SUCCESS = 'CashBoxReplacementTab/ fetch replacement history success',
    FETCH_CASHBOX_REPLACEMENT_HISTORY_ERROR = 'CashBoxReplacementTab/ fetch replacement history error',
    DOWNLOAD_REPLACEMENT_HISTORY = 'CashBoxReplacementTab/ download replacement history as excel',
    DOWNLOAD_REPLACEMENT_HISTORY_SUCCESS = 'CashBoxReplacementTab/ download replacement history as excel success',
    DOWNLOAD_REPLACEMENT_HISTORY_ERROR = 'CashBoxReplacementTab/ download replacement history as excel error',
}

export const exitCashBoxReplacementTabAction = () =>
    createAction(CashBoxReplacementTabActionType.EXIT_CASHBOX_REPLACEMENT_TAB);

export const fetchCashBoxReplacementHistoryAction = () =>
    createAction(CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY);

export const fetchCashBoxReplacementHistorySuccessAction = (payload: CashBoxReplacementHistoryDto) =>
    createAction(CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY_SUCCESS, payload);

export const fetchCashBoxReplacementHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY_ERROR, { notification });

export const downloadReplacementHistoryAction = () =>
    createAction(CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY);

export const downloadReplacementHistorySuccessAction = () =>
    createAction(CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY_SUCCESS);

export const downloadReplacementHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY_ERROR, { notification });

export type CashBoxReplacementTabAction =
    | ReturnType<typeof exitCashBoxReplacementTabAction>
    | ReturnType<typeof fetchCashBoxReplacementHistoryAction>
    | ReturnType<typeof fetchCashBoxReplacementHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxReplacementHistoryErrorAction>
    | ReturnType<typeof downloadReplacementHistoryAction>
    | ReturnType<typeof downloadReplacementHistorySuccessAction>
    | ReturnType<typeof downloadReplacementHistoryErrorAction>;
